module.exports = __webpack_public_path__ + "img/logo.1e1ee6c6.png";